import React, { Component, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ipc/ipc-components';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import OperatorImpcSelectionContainer
  from '../../../../common/selection-criteria/operator-impc/container/OperatorImpcSelectionContainer';
import { getLeftCheckedMailProcessingCenters } from '../../../../common/user/redux/selectors/UserDataSelectors';
import { onLeftMailProcessingCenterChecked } from '../../../../common/selection-criteria/operator-impc/redux/actions/OperatorImpcActions';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class BalanceOnHandReportSelectionCriteriaContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      validDate: true,
    };
  }

  onInvalidDate = (message) => {
    this.setState({
      validDate: message === '',
    });
  }

  isApplyEnabled = () => (this.props.checkedMailProcessingCenters.length > 0 && this.state.validDate)

  togglePanel = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  apply = () => {
    this.props.onApply();
    this.togglePanel();
  }

  render() {
    return (
      <div>
        <div className="selection-criteria-container">
          <h3 className="title-div">{this.props.title}</h3>
          <div className="operator-selector-wrapper">
            <div className="operators">
              <div className="operators-selection-panel">
                <div className="operator">
                  <div className="expand-div-button">
                    <h6>
                      SELECTION CRITERIA
                    </h6>
                    <div onClick={(e) => this.togglePanel(e)} className="expand-button">
                      <FontAwesomeIcon icon={this.state.open ? 'angle-down' : 'angle-right'} className="expand-icon" />
                    </div>
                  </div>
                  <div className={`checkboxtree-div ${this.state.open}`}>
                    <div>
                      <OperatorImpcSelectionContainer
                        {...this.props}
                      />
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                        <Grid container>
                          <KeyboardDatePicker
                            disableToolbar
                            autoOk
                            format="dd-MM-yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label="Date: "
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            value={this.props.selectedDate}
                            onChange={this.props.onDateChange}
                            onError={this.onInvalidDate}
                          />
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </div>
                    <div>
                      <Button
                        disabled={!this.isApplyEnabled()}
                        className={`apply-div-${!this.isApplyEnabled()}`}
                        onClick={this.apply}
                      >
                        APPLY
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    checkedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  onLeftMailProcessingCenterChecked,
}, dispatch);

BalanceOnHandReportSelectionCriteriaContainer.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  selectedDate: PropTypes.instanceOf(Date),
  onDateChange: PropTypes.func,
  onApply: PropTypes.func,
};

BalanceOnHandReportSelectionCriteriaContainer.defaultProps = {
  open: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(BalanceOnHandReportSelectionCriteriaContainer);
